import React, { FC } from 'react';
import { Col, Row } from 'reactstrap';
import { MenuLink } from '../../../../shared/config';
import { InlineHelp } from '../../../components';
import { Fetcher, useFetcher } from '../../../utils';
import { ColumnSetting, DataTable } from './DataTable';

const menuLinkColumns: ColumnSetting<MenuLink>[] = [
  {
    name: 'name',
    type: 'text',
  },
  {
    name: 'url',
    type: 'text',
  },
  {
    label: (
      <>
        icon <InlineHelp href="https://material.io/resources/icons/">Icon References</InlineHelp>
      </>
    ),
    name: 'icon',
    type: 'text',
  },
  {
    name: 'order',
    type: 'number',
  },
  {
    enumValues: [
      {
        name: 'Application',
        value: 'application',
      },
      {
        name: 'Attendance',
        value: 'attendance',
      },
    ],
    name: 'type',
    type: 'enum',
  },
  {
    name: 'newTab',
    type: 'toggle',
    label: <>Open in a New Tab</>,
  },
];

export const MenuLinkSettings: FC = () => {
  const fetch = useFetcher(async () => await api.getMenuLinks());

  return (
    <Row>
      <Col className="mb-10" id="menuLinkSettings" xs={12}>
        {fetch.data ? (
          <DataTable<MenuLink>
            columns={menuLinkColumns}
            data={fetch.data}
            endpoint="/api/menulinks"
            refresh={fetch.refresh}
            title="menu_link"
          />
        ) : (
          <Fetcher inline result={fetch} />
        )}
      </Col>
    </Row>
  );
};
